import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import Row from "react-bootstrap/Row";
import { Link, Redirect } from "react-router-dom";
// Adjust the path to where you placed your SVG file
import { BasicLoader } from "ui/loader";
import { Notification } from "ui/notification";

import loginImage from "../../../static/image/vm-logo-stacked-white.svg";

class LoginPage extends React.PureComponent {
  static get propTypes() {
    return {
      // We need to hide the password recovery link on non-Fleet login pages
      // since the controllers are not ready to handle those requests. We can
      // get rid of this once we combine the controllers.
      enablePasswordRecovery: PropTypes.bool,
      isAuthenticated: PropTypes.bool.isRequired,
      location: PropTypes.object.isRequired,
      onLogin: PropTypes.func.isRequired,
      sessionExpired: PropTypes.bool,
      storesLoaded: PropTypes.bool.isRequired,
      title: PropTypes.string.isRequired,
    };
  }

  static get defaultProps() {
    return {
      enablePasswordRecovery: false,
    };
  }

  constructor() {
    super();

    this.state = {
      email: "",
      loginSuccess: false,
      password: "",
      submitted: false,
    };

    this.doLogin = this.doLogin.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.submit = this.submit.bind(this);
    this.updateEmail = this.updateEmail.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
  }
  
  componentWillUnmount() {
    this._isMounted = false;
  }

  alertMessage() {
    const { sessionExpired } = this.props;

    return sessionExpired
      ? "Your session has expired. Please login again."
      : "";
  }

  doLogin() {
    const { onLogin } = this.props;
    const { email, password } = this.state;

    return onLogin(email, password)
      .then(() => {
        if (this._isMounted) {
          this.setState({ loginSuccess: true });
        }
      })
      .finally(() => {
        if (this._isMounted) {
          this.setState({ submitted: false });
        }
      });
  }

  handleKeyPress(e) {
    if (e.key === "Enter") {
      this.submit();
    }
  }

  submit() {
    const { loginSuccess, submitted } = this.state;

    if (submitted || loginSuccess) {
      return;
    }

    this.setState({ submitted: true }, this.doLogin);
  }

  updateEmail(e) {
    this.setState({ email: e.currentTarget.value });
  }

  updatePassword(e) {
    this.setState({ password: e.currentTarget.value });
  }

  render() {
    const {
      enablePasswordRecovery,
      isAuthenticated,
      location,
      storesLoaded,
      title,
    } = this.props;
    const { loginSuccess, submitted } = this.state;
    const passwordRecoveryClasses = classNames({
      hide: !enablePasswordRecovery,
      "forgot-password": true,
    });

    if (!storesLoaded) {
      return <BasicLoader />;
    }

    if (isAuthenticated) {
      const { state = {} } = location;
      const { nextLocation = {} } = state;

      if (nextLocation.pathname && nextLocation.pathname !== "/login") {
        return <Redirect to={nextLocation} />;
      }

      return <Redirect to="/" />;
    }

    return (
      <div className="login-page">
        <div className="header">
          <h1>{title}</h1>
        </div>
        <div className="login-container">
          <div className="login-box">
            <div className="login-box-body">
              <p className="login-box-msg">Sign in to start your session</p>
              <Notification error={this.alertMessage()} />
              <Form onKeyPress={this.handleKeyPress}>
                <FormGroup>
                  <FormControl
                    type="email"
                    onChange={this.updateEmail}
                    autoComplete="username"
                    placeholder="Email"
                    disabled={loginSuccess}
                  />
                </FormGroup>
                <FormGroup>
                  <FormControl
                    type="password"
                    onChange={this.updatePassword}
                    autoComplete="current-password"
                    placeholder="Password"
                    disabled={loginSuccess}
                  />
                </FormGroup>
              </Form>
              <Row>
                <Col xs={{ span: 4, offset: 5 }}>
                  <Link
                    to="/login/forgot-password"
                    className={passwordRecoveryClasses}
                  >
                    Forgot Password?
                  </Link>
                </Col>
                <Col xs={3}>
                  <Button
                    variant="primary"
                    disabled={submitted || loginSuccess}
                    onClick={this.submit}
                  >
                    Sign In
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
          <div className="login-logo">
            <img src={loginImage} alt="Description" className="login-image" />
          </div>
        </div>
      </div>
    );
  }
}

export { LoginPage };
